export default "__VITE_ASSET__dqwuJ5jl__"